import React, { useContext, useEffect, useState } from "react";
import { Space, Flex, Input, Button, Divider, Empty, App } from 'antd'
import { FaSearch } from "react-icons/fa";
import _ from "lodash";
import dayjs from "dayjs";
import { API } from "../../../resources/constants"
import language from "../../../resources/languages/en_US"

// Interfaces
import { Ask as AskType } from "../../../interfaces/pages/opportunities"
import { AxiosError } from "../../../interfaces/axios";

// Contexts
import AxiosContext from "../../../contexts/axios";

const { TENDER_CHAT_ALL } = API
const { Pages: { Opportunities: { Tender } }, Share, Validation, Message: MessageLanguage, Enum: EnumLanguage } = language

export default function AskHistory(props: { source: string, tenderId: string, askId: string|null, asks: AskType[], loadingAsk: boolean, loadingMessages: boolean, askHistorySearchReset: boolean, setAskId: (askId: string|null) => void, setShowAskBox: (showAskBox: boolean) => void, setAsks: (asks: AskType[]) => void }) {
    const { source, tenderId, askId, asks, loadingAsk, loadingMessages, askHistorySearchReset, setAskId, setShowAskBox, setAsks } = props;

    const { axios } = useContext(AxiosContext)
    const [loadingAsks, setLoadingAsks] = useState<boolean>(false)
    const [searchValue, setSearchValue] = useState<string>('')
    const { message, modal } = App.useApp()

    useEffect(() => {
        setSearchValue('');
    }, [askHistorySearchReset])

    const getAsks = async (title: string): Promise<AskType[]> => {
        setLoadingAsks(true);
        return axios.post(TENDER_CHAT_ALL, { tender: tenderId, title }, { params: { source, loading: false } }).then((response: { data: AskType[] }) => {
            const { data: asks } = response;
            setAsks(asks);
            setLoadingAsks(false);
            return asks;
        }).catch((error: AxiosError) => {
            const { response: { data } } = error;
            setAsks([]);
            setAskId(null);
            setLoadingAsks(false);
            // @ts-ignore
            message.error(MessageLanguage[data.message]||data.message).then(response => response )
        })
    }

    return (
        <Space direction={'vertical'} size={15}>
           <div className={'search'}>
               <Input
                   value={searchValue}
                   placeholder={Tender.search}
                   disabled={loadingAsk || loadingMessages}
                   size="large"
                   prefix={
                       <Button
                           type={'text'}
                           disabled={loadingAsk || loadingMessages}
                           icon={<FaSearch size={22} />}
                           loading={loadingAsks}
                           style={{cursor:'default'}}
                       />
                   }
                   onChange={async ({ target: { value }}) => {
                       setSearchValue(value);
                       await getAsks(value);
                   }}
               />
               <Divider />
           </div>
            <Space direction={'vertical'} className={'asks'} size={2} style={{width:'100%'}}>
                {
                    _.isEmpty(asks) ? <Empty description={Share.noAsk} /> : asks.map(({ id, title, description, updatedAt}) => id && title && description && updatedAt && (
                        <Flex gap={10} className={(id === askId) ? 'message active' : 'message'} style={{cursor: (loadingAsk || loadingMessages) ? 'default' : 'pointer'}} onClick={() => {
                            if (!loadingAsk && !loadingMessages) {
                                setAskId(id);
                                setShowAskBox(true);
                            }
                        }}>
                            <Space direction={'vertical'} size={2} style={{width:'100%'}}>
                                <span className={'title'}>{title.substring(0,23)} ...</span>
                                <span className={'description'}>{description.substring(0,23)} ...</span>
                            </Space>
                            <span className={'date'}>{dayjs(updatedAt).tz(process.env.REACT_APP_TZ).format('D MMMM')}</span>
                        </Flex>
                    ))
                }
            </Space>
        </Space>
    )
}